import type { ReactNode } from 'react';

export const symbol_shades: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M152-80q-14 0-23-7.5t-9-24.5v-713h-10q-13 0-21.5-8.5T80-855q0-13 8.5-21.5T110-885h740q13 0 21.5 8.5T880-855q0 13-8.5 21.5T850-825h-11v713q0 17-9 24.5T807-80q-80 0-145.5-69T579-290H380q-17 72-82.5 141T152-80Zm28-70q65-21 106-76t41-124v-475H180v675Zm207-200h186v-475H387v475Zm392 200v-675H633v475q0 69 40 124t106 76ZM327-825H180h147Zm452 0H633h146Z"
		/>
	</svg>
);
